import './StoreAssociationPage.less';

export const prefix = 'bm-p-store-association';

export { default } from './StoreAssociationPage';
